import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, consultaDocumentos } from './types';

export const INITIAL_STATE: consultaDocumentos = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): consultaDocumentos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_DOCUMENTOS_REQUEST: {
				break;
			}

			case Types.CONSULTA_DOCUMENTOS_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.CONSULTA_DOCUMENTOS_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.LIMPA_CONSULTA_DOCUMENTOS: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}

		return draft;
	});
}
